/* Rising Sun FPV - speed helpers (theme V4.0)
   Phone menu on demand: pages now ship an empty phone menu (see snippets/mobile-menu.liquid) instead of about 270 KB of
   menu HTML. On phones and tablets this fills it in once the page has loaded, or straight away when the menu button is
   touched. The first page of a visit fetches the menu; it is then kept for the rest of the visit (sessionStorage), so
   later pages swap it in without fetching. The theme's menu code looks panels up at click time, so it keeps working.
   Nothing is fetched on computers, where the phone menu is never shown. */
(function () {
  'use strict';
  var menu = document.querySelector('#mobile-menu[data-rs-mm-lazy]');
  if (!menu) return;

  /* The header lives in a section group, so ask for it by its own section id (set in snippets/mobile-menu.liquid). */
  var SID = menu.getAttribute('data-rs-mm-section') || 'header';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SRC = ROOT + 'pages/rs-mobile-menu?section_id=' + encodeURIComponent(SID);
  var KEY = 'rsMobileMenu:' + ((window.Shopify && window.Shopify.theme && window.Shopify.theme.id) || '') + ':' + SID;
  var state = 'idle'; /* idle | loading | done */

  function pick(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function swapIn(fresh) {
    var current = menu.querySelector('.mobile-menu__inner');
    if (!fresh || !current || fresh.classList.contains('rs-mm-wait')) throw new Error('menu not found');
    current.parentNode.replaceChild(document.importNode(fresh, true), current);
    menu.removeAttribute('data-rs-mm-lazy');
    state = 'done';
  }

  function load() {
    if (state !== 'idle') return;

    /* Already fetched earlier in this visit: use that copy, no network needed. */
    var kept = null;
    try { kept = window.sessionStorage.getItem(KEY); } catch (e) {}
    if (kept) {
      try { swapIn(pick(kept, '.mobile-menu__inner')); return; } catch (e) { state = 'idle'; }
    }

    state = 'loading';
    fetch(SRC, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var fresh = pick(html, '#mobile-menu .mobile-menu__inner');
        swapIn(fresh);
        try { window.sessionStorage.setItem(KEY, fresh.outerHTML); } catch (e) {}
      })
      .catch(function () {
        state = 'idle';
        var wait = menu.querySelector('.rs-mm-wait__text');
        if (wait) wait.textContent = 'The full menu didn’t load. Use the links below, or try again.';
      });
  }

  var toggle = document.querySelector('[aria-controls="mobile-menu"]');
  if (toggle) {
    ['pointerdown', 'touchstart', 'focus', 'click'].forEach(function (ev) {
      toggle.addEventListener(ev, load, { passive: true });
    });
  }

  /* Warm it up on phones and tablets once the page has settled (the phone menu is hidden from 1000px up). */
  var small = !window.matchMedia || window.matchMedia('(max-width: 999px)').matches;
  if (!small) return;
  function warm() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 3000 });
    else window.setTimeout(load, 1500);
  }
  if (document.readyState === 'complete') warm();
  else window.addEventListener('load', warm);
})();